import { format } from "date-fns";
import commandxLogo from "@/assets/commandx-logo.png";

export const CommandXFooter = () => (
  <div className="mt-12 pt-4 text-center" style={{ borderTop: "1px solid #eee" }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginBottom: 4 }}>
      <img src={commandxLogo} alt="CommandX" style={{ height: 22, objectFit: "contain" }} />
      <span style={{ fontSize: 10, color: "#999" }}>Powered by CommandX Ops Center</span>
    </div>
    <p style={{ fontSize: 9, color: "#bbb" }}>
      Generated on {format(new Date(), "MMMM d, yyyy 'at' h:mm a")}
    </p>
  </div>
);
